// ZAKAZKA_ADRESA_V1 (Mirko 21. 10. 2026): adresa v bunkách — JEDEN spôsob adresy v Matrixe (0.J), rovnaké pravidlá ako server
// (server.js adresaRozloz / adresaSloz z ZAMESTNANEC_ADRESA_V1 a adresaRozlozStavba). Bunky: ulica, číslo, PSČ, obec, štát;
// jeden riadok „ulica číslo, PSČ obec[, štát]“ sa z nich len poskladá pre čitateľov (dokumenty, počasie, Denník, PDF).
// PARTNER_ADRESA_V1 (21. 10. 2026): to isté pre partnera (customers) — štát na konci, poľské PSČ, sídlo z registra po bunkách.
export const ADRESA_CASTI = ['adresa_ulica', 'adresa_cislo', 'adresa_psc', 'adresa_obec', 'adresa_stat']
// PARTNER_ADRESA_V1: štát napísaný na konci riadku („…, Poľsko“) patrí do bunky Štát, nie do Obce
export const ADRESA_STATY = ['SK', 'SR', 'SLOVENSKO', 'SLOVENSKÁ REPUBLIKA', 'CZ', 'ČR', 'ČESKO', 'ČESKÁ REPUBLIKA', 'PL', 'POĽSKO', 'POLSKO', 'POLSKA',
  'HU', 'MAĎARSKO', 'AT', 'RAKÚSKO', 'DE', 'NEMECKO', 'UA', 'UKRAJINA']

export function adresaRozloz(s) {
  const t = String(s || '').replace(/\s+/g, ' ').trim()
  const o = { adresa_ulica: '', adresa_cislo: '', adresa_psc: '', adresa_obec: '', adresa_stat: 'SK' }
  if (!t) return o
  const m = t.match(/^(.*?),?\s*(\d{3})\s?(\d{2})\s+([^,]+?)(?:,\s*(.+))?$/)
  if (!m) { o.adresa_ulica = t; return o }
  const ul = m[1].replace(/,\s*$/, '').trim(); const mc = ul.match(/^(.*\D)\s+(\d[\w/-]*)$/)
  o.adresa_ulica = mc ? mc[1].trim() : ul; o.adresa_cislo = mc ? mc[2] : ''
  o.adresa_psc = m[2] + ' ' + m[3]; o.adresa_obec = m[4].trim(); if (m[5]) o.adresa_stat = m[5].trim()
  return o
}

// PARTNER_ADRESA_V1: obec bez ulíc — Ulica = názov obce, Číslo = číslo domu, ako pri zamestnancovi („094 02 Kvakovce 900“, „34, 094 07 Nižná Sitnica“);
// text za obcou, ktorý nie je štát („…, Michalovce (5 km od …)“), ostáva pri obci
function adresaUprav(o) {
  if (o.adresa_stat && !ADRESA_STATY.includes(o.adresa_stat.toUpperCase())) { o.adresa_obec = [o.adresa_obec, o.adresa_stat].filter(Boolean).join(', '); o.adresa_stat = 'SK' }
  if (!o.adresa_cislo && /^\d[\w/-]*$/.test(o.adresa_ulica) && o.adresa_obec) { o.adresa_cislo = o.adresa_ulica; o.adresa_ulica = o.adresa_obec.replace(/\s+\d+$/, '') }
  else if (!o.adresa_ulica && !o.adresa_cislo && o.adresa_psc) { const m = o.adresa_obec.match(/^(.*\D)\s+(\d[\w/-]*)$/); if (m) { o.adresa_ulica = m[1].trim(); o.adresa_cislo = m[2]; o.adresa_obec = m[1].trim() } }
  return o
}

// miesto stavby býva len obec alebo voľný text: plný tvar s PSČ ako pri zamestnancovi, inak čiarky (posledná časť = obec), jedna časť bez čísla = obec
export function adresaRozlozStavba(s) {
  const t = String(s || '').replace(/\s+/g, ' ').trim()
  const r = adresaRozloz(t); if (!t || r.adresa_psc) return adresaUprav(r)
  const o = { adresa_ulica: '', adresa_cislo: '', adresa_psc: '', adresa_obec: '', adresa_stat: 'SK' }
  let casti = t.split(',').map(x => x.trim()).filter(Boolean)
  if (casti.length >= 2 && ADRESA_STATY.includes(casti[casti.length - 1].toUpperCase())) o.adresa_stat = casti.pop()   // PARTNER_ADRESA_V1
  casti = casti.map(c => { const m = c.match(/^(.*?)\s*(\d{3})\s?(\d{2})$/); if (m && !o.adresa_psc && (m[1] === '' || /\D$/.test(m[1]))) { o.adresa_psc = m[2] + ' ' + m[3]; return m[1].trim() }
    const p = !o.adresa_psc && c.match(/^(\d{2}-\d{3})\s+(.+)$/); if (p) { o.adresa_psc = p[1]; return p[2].trim() } return c }).filter(Boolean)   // PARTNER_ADRESA_V1: poľské PSČ „32-020 Wieliczka“
  const ulica = (u) => { const mc = u.match(/^(.*\D)\s+(\d[\w/-]*)$/); o.adresa_ulica = mc ? mc[1].trim() : u; o.adresa_cislo = mc ? mc[2] : '' }
  if (casti.length >= 2) { o.adresa_obec = casti[casti.length - 1]; ulica(casti.slice(0, -1).join(', ')) }
  else if (casti.length === 1) { if (/\d/.test(casti[0]) && !o.adresa_psc) ulica(casti[0]); else o.adresa_obec = casti[0] }
  return adresaUprav(o)
}

export function adresaSloz(o) {
  const psc = String(o.adresa_psc || '').replace(/\s+/g, '').match(/^\d{5}$/) ? String(o.adresa_psc).replace(/\s+/g, '').replace(/^(\d{3})(\d{2})$/, '$1 $2') : String(o.adresa_psc || '').trim()
  const ul = [o.adresa_ulica, o.adresa_cislo].map(x => String(x || '').trim()).filter(Boolean).join(' ')
  const ob = [psc, o.adresa_obec].map(x => String(x || '').trim()).filter(Boolean).join(' ')
  const st = String(o.adresa_stat || '').trim()
  return [ul, ob, (st && !['SK', 'SLOVENSKO', 'SLOVENSKÁ REPUBLIKA'].includes(st.toUpperCase())) ? st : ''].filter(Boolean).join(', ')
}

// PARTNER_ADRESA_V1: sídlo z registra (ORSR, RPO, ARES, PL, VIES, FinStat) do buniek z častí, ktoré register vracia
// (ulica s číslom, obec, PSČ, štát); keď ich server už poslal po bunkách, vezmú sa tie; bez častí sa rozloží riadok.
export function adresaZRegistra(d) {
  d = d || {}
  if (ADRESA_CASTI.some(k => d[k] !== undefined)) { const o = {}; ADRESA_CASTI.forEach(k => { o[k] = String(d[k] || '').trim() }); if (!o.adresa_stat) o.adresa_stat = 'SK'; return o }
  const ul = String(d.street || '').replace(/\s+/g, ' ').trim(); const ob = String(d.city || '').replace(/\s+/g, ' ').trim()
  if (!ul && !ob) return adresaRozlozStavba(d.address)
  const o = { adresa_ulica: ul, adresa_cislo: '', adresa_psc: '', adresa_obec: ob, adresa_stat: String(d.country || '').trim().toUpperCase() || 'SK' }
  const mc = ul.match(/^(.*\D)\s+(\d[\w/-]*)$/)
  if (mc) { o.adresa_ulica = mc[1].trim(); o.adresa_cislo = mc[2] } else if (/^\d[\w/-]*$/.test(ul)) { o.adresa_ulica = ob; o.adresa_cislo = ul }   // obec bez ulíc: ulica = názov obce
  const z = String(d.zip || '').replace(/\s+/g, '')
  o.adresa_psc = /^\d{5}$/.test(z) ? z.slice(0, 3) + ' ' + z.slice(3) : String(d.zip || '').trim()
  return o
}

// PARTNER_ADRESA_V1: bunky do formulára — uložené, a keď sú prázdne (záznam založil iný modul), rozložené z jedného riadku `pole`
export function adresaBunky(r, pole) {
  r = r || {}
  const q = ['adresa_ulica', 'adresa_cislo', 'adresa_psc', 'adresa_obec'].some(k => String(r[k] || '').trim()) ? r : adresaRozlozStavba(r[pole])
  const o = {}; ADRESA_CASTI.forEach(k => { o[k] = String(q[k] || '').trim() }); if (!o.adresa_stat) o.adresa_stat = 'SK'
  return o
}
